import React from 'react';

const TextFormatter = ({ value }) => <div>{value}</div>;

export default TextFormatter;
